import {
  ClerkAPIResponseError,
  ClerkRuntimeError,
  EmailLinkError,
  EmailLinkErrorCode,
  MagicLinkError,
  MagicLinkErrorCode,
  buildErrorThrower,
  is4xxError,
  isClerkAPIResponseError,
  isClerkRuntimeError,
  isEmailLinkError,
  isKnownError,
  isMagicLinkError,
  isMetamaskError,
  isNetworkError,
  isUnauthorizedError,
  isUserLockedError,
  parseError,
  parseErrors
} from "./chunk-5DRMPUGE.mjs";
import "./chunk-KJVJ4CFF.mjs";
import "./chunk-NDCDZYN6.mjs";
export {
  ClerkAPIResponseError,
  ClerkRuntimeError,
  EmailLinkError,
  EmailLinkErrorCode,
  MagicLinkError,
  MagicLinkErrorCode,
  buildErrorThrower,
  is4xxError,
  isClerkAPIResponseError,
  isClerkRuntimeError,
  isEmailLinkError,
  isKnownError,
  isMagicLinkError,
  isMetamaskError,
  isNetworkError,
  isUnauthorizedError,
  isUserLockedError,
  parseError,
  parseErrors
};
//# sourceMappingURL=error.mjs.map